import axios from "axios";

export const makeRequest = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 20000, // <-- added
  headers: {
    Authorization: "bearer " + process.env.REACT_APP_API_TOKEN,
  },
});
